import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { DocumentationImportKindEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import Typography from '@lib/components/Typography/Typography';
import DocumentImportFormFieldNames from '@lib/enums/fieldNames/documentImportFormFieldNames';
import styles from './CountersFooter.module.scss';

interface Props {
  values: Values;
}

function getDocumentsCount(values: Values): number {
  const sourceKind = _get(values, [
    DocumentImportFormFieldNames.SourceKind,
    'value',
  ]) as DocumentationImportKindEnum | undefined;
  if (sourceKind === DocumentationImportKindEnum.Files) {
    const files = (_get(values, DocumentImportFormFieldNames.Files) ||
      []) as unknown[];
    return files.length;
  }
  if (sourceKind === DocumentationImportKindEnum.Archive) {
    const archive = (_get(values, DocumentImportFormFieldNames.Archive) ||
      []) as unknown[];
    return archive.length ? 1 : 0;
  }
  if (sourceKind === DocumentationImportKindEnum.Ftp) {
    // Populated by the FTP preview on step 1 (FtpPreviewBlock).
    const ftpCount = _get(
      values,
      DocumentImportFormFieldNames.FtpSupportedFilesCount,
    ) as number | undefined;
    return Number(ftpCount) || 0;
  }
  return 0;
}

export default function CountersFooter({ values }: Props) {
  const { t } = useTranslation();
  const count = getDocumentsCount(values);

  return (
    <div className={styles.root}>
      <Typography variant="label" block>
        {t('documents-import-total-documents', { count })}
      </Typography>
    </div>
  );
}
